import React, { useState, useEffect } from 'react';
import Modal from '../../common/components/Modal/modal';
import searchDelete from '../../images/icons/searchDelete.svg';
import SearchIcon from '../../images/icons/searchIcon.svg';

const AssignMultipleLeads = ({
  showModal,
  setShowModal,
  LeadSelectionData
}) => {
  const [searchIcon, setSearchIcon] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [assgineeeOptions, setAssigneeOptions] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [masterResponse, storeMasterResponse] = useState([]);
  const [totlLeads, setTotleLeads] = useState('');

  const handleOnSelection = value => {
    setSearchValue(value.fullName);
    setSearchIcon(false);
    setAssigneeOptions([]);
    if (!value) return;
    setSelectedValue(value);
  };

  useEffect(() => {
    let i = 0;
    for (var key in LeadSelectionData) {
      if (LeadSelectionData[key]) ++i;
    }
    setTotleLeads(i);
  }, []);

  const handleSubmittion = () => {};

  const updateList = e => {
    setSearchValue(e.target.value);
    let newList = [];
    masterResponse.map(each => {
      if (
        !each?.fullName?.toLowerCase().includes(e?.target?.value?.toLowerCase())
      )
        return;
      newList.push(each);
    });
    setAssigneeOptions(newList);
  };

  const handleReset = () => {
    setSearchValue('');
    setSearchIcon(true);
    setAssigneeOptions(masterResponse);
  };
  return (
    <div className="w-full bg-white ">
      <Modal
        show={showModal}
        setShow={setShowModal}
        title={
          <div className="w-full">
            <p className="text-base text-left">Assign to RM</p>
            <p
              className="text-sm text-grey-995 text-left mt-1"
              style={{ fontWeight: 400 }}
            >
              {`${totlLeads} Leads selected`}
            </p>
          </div>
        }
      >
        <div className="w-full" style={{ minHeight: '150px' }}>
          <div className="w-12/12 mx-auto flex px-1 mt-2 bg-grey-100  items-center rounded  border-0">
            <input
              className="w-10/12 placeholder-grey-1001 ml-3 text-sm font-roboto font-normal h-10  bg-grey-100"
              placeholder="Search RM"
              onChange={updateList}
              disabled={!searchIcon}
              value={searchValue}
            />
            {searchIcon ? (
              <img
                src={SearchIcon}
                alt="search rm "
                className="w-9 ml-auto py-1 "
              />
            ) : (
              <img
                src={searchDelete}
                className="w-4  ml-auto cursor-pointer "
                alt="delete"
                onClick={handleReset}
              />
            )}
          </div>
          <div
            className={`block w-11/12  mx-auto relative  shadow rounded  ${
              assgineeeOptions.length == 0 ? 'mb-14' : ' mb-10 overflow-auto'
            }`}
            style={{ maxHeight: '140px' }}
          >
            <div className="text-left font-roboto font-normal text-sm text-black-500 px-2  my-2">
              {assgineeeOptions.map(each => {
                return (
                  <div className="py-3 w-full">
                    <span
                      className="cursor-pointer"
                      onClick={() => handleOnSelection(each)}
                    >
                      {each.fullName}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
          {!searchIcon ? (
            <div className="w-full flex ">
              <button className="w-24 px-3 py-3 bg-grey-1002 text-grey-1003 font-roboto font-normal rounded ml-auto  ">
                Cancel
              </button>
              <button
                type="button"
                className={
                  searchIcon || submitting
                    ? 'w-24 px-3 py-3 bg-grey-1002 text-grey-1003 font-roboto font-normal rounded mx-3 bg-grey-1002 text-white font-bold py-2 px-4 rounded  cursor-not-allowed'
                    : 'w-24 px-3 py-3 bg-green-600 text-white font-roboto font-normal rounded mx-3 bg-grey-1002 text-white font-bold py-2 px-4 rounded'
                }
                disabled={searchIcon}
                onClick={handleSubmittion}
              >
                Assign
              </button>
            </div>
          ) : null}
        </div>
      </Modal>
    </div>
  );
};

export default AssignMultipleLeads;
